import React, { MouseEventHandler, useEffect, useState } from 'react';
import { MenuItem, Select } from '@material-ui/core';
import { SearchWrapper } from 'components/SearchBarFeeNote/styled-component';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'components/SearchBar/messages';
import { translate } from 'containers/services/translate';

import {
  RefreshButton,
  SearchButton,
  StyledInputBase,
} from 'components/NewSearchBar/style';
import { SEARCH_TYPE_IDS } from 'components/SearchBarFeeNote/constants';
import { isEmpty } from 'lodash';
import { COLORS } from 'constants/design';
import {
  PRIVILEGES,
  userHasPrivilege,
} from 'containers/services/security/user-privileges';
export interface SearchQuery {
  claimNumber: string | null;
  policyNumber?: string | null;
  registrationNumber?: string | null;
}
export interface SearchBarProps {
  intl: IntlShape;
  searchQuery: SearchQuery;
  setSearchQuery: Function;
  handleSearch: Function;
  handlerRefresh: MouseEventHandler;
}

const SearchBarFeeNote: React.FC<SearchBarProps> = (props): JSX.Element => {
  const [searchType, setSearchType] = useState([] as any);
  const [selectedSearchType, setSelectedSearchType] = useState(
    SEARCH_TYPE_IDS.CLAIM_NUMBER,
  );
  const { searchQuery, setSearchQuery } = props;

  /* istanbul ignore next */
  const handleChangeSelectedSearchType = (
    e: React.ChangeEvent<{ value: unknown }>,
  ) => {
    setSelectedSearchType(e.target.value as string);
  };

  const [searchValue, setSearchValue] = useState<string | null>(null);
  /* istanbul ignore next */
  const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value.trim());
  };
  const [searchValuePlaceHolder, setSearchValuePlaceHolder] = useState('');
  const isPreOpeningManager = userHasPrivilege(PRIVILEGES.ISPREOPENMANAGER);

  useEffect(() => {
    setSearchType(allSearchTypes[isPreOpeningManager ? 'GPO' : 'DEFAULT']);
  }, []);

  const allSearchTypes = {
    DEFAULT: [
      {
        id: SEARCH_TYPE_IDS.CLAIM_NUMBER,
        title: translate(messages.claimNumber, props),
      },
      {
        id: SEARCH_TYPE_IDS.POLICY_NUMBER,
        title: translate(messages.policyNumber, props),
      },
      {
        id: SEARCH_TYPE_IDS.REGISTRATION_NUMBER,
        title: translate(messages.registrationNumber, props),
      },
    ],
    GPO: [
      {
        id: SEARCH_TYPE_IDS.CLAIM_NUMBER,
        title: translate(messages.claimNumber, props),
      },
      {
        id: SEARCH_TYPE_IDS.POLICY_NUMBER,
        title: translate(messages.policyNumber, props),
      },
    ],
  };

  useEffect(() => {
    const result = searchType.find(
      (type: { id: string }) => type.id === selectedSearchType,
    );
    if (result) setSearchValuePlaceHolder(`Saisir ${result.title}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSearchType, !isEmpty(searchType)]);

  /* istanbul ignore next */
  const assignValuesToSearchQueryBeforeSearch = () => {
    searchQuery.claimNumber = null;
    searchQuery.policyNumber = null;
    searchQuery.registrationNumber = null;
    switch (selectedSearchType) {
      case SEARCH_TYPE_IDS.CLAIM_NUMBER:
        searchQuery.claimNumber = searchValue;
        break;
      case SEARCH_TYPE_IDS.POLICY_NUMBER:
        searchQuery.policyNumber = searchValue;
        break;
      case SEARCH_TYPE_IDS.REGISTRATION_NUMBER:
        searchQuery.registrationNumber = searchValue;
        break;
    }
    setSearchQuery(searchQuery);
    props.handleSearch();
  };

  return (
    <SearchWrapper>
      <Select
        value={selectedSearchType}
        onChange={handleChangeSelectedSearchType}
        input={
          <StyledInputBase borderRadiusLeft fullWidth textColor="black" bold />
        }
        data-testid="search-type"
      >
        {searchType.map((searchType: any) => (
          <MenuItem value={searchType.id}>{searchType.title}</MenuItem>
        ))}
      </Select>
      <StyledInputBase
        marginRight
        borderRadiusRight
        fullWidth
        textColor="black"
        bgColor={COLORS.FORM_INPUT_BG_GRAY}
        className="inputBase"
        placeholder={searchValuePlaceHolder}
        name="queryNumber"
        value={searchValue}
        onChange={handleChangeSearchValue}
        inputProps={{
          'aria-label': 'searchedValue',
          className: 'inputTextStyle',
        }}
      />
      <SearchButton
        data-testid="search-button"
        onClick={assignValuesToSearchQueryBeforeSearch}
      >
        <SearchIcon />
      </SearchButton>
      <RefreshButton
        data-testid="refresh-button"
        onClick={props.handlerRefresh}
      >
        <RefreshIcon />
      </RefreshButton>
    </SearchWrapper>
  );
};

export default injectIntl(SearchBarFeeNote);
